<template>
  <v-simple-table dense class="ml-1">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            TIPO
          </th>
          <th class="text-center">
            <Tipo />
          </th>
          <th class="text-left">
            TEXTURA
          </th>
          <th class="text-left">
            <Textura />
          </th>
        </tr>
        <tr>
          <th class="text-left">
            ACABADO
          </th>
          <th class="text-left">
            <Acabado />
          </th>
          <th class="text-left">
            FORMATO
          </th>
          <th class="text-left">
            <Formato />
          </th>
        </tr>
      </thead>

    </template>
  </v-simple-table>
</template>

<script>
import Tipo from "./Tipo"
import Formato from "./Formato"
import Textura from "./Textura"
import Acabado from "./Acabado"
export default {
  components: {
    Tipo,
    Formato,
    Textura,
    Acabado
  }
}
</script>

<style></style>